<div id="story-readonly-header">
  <button id="story-readonly-close-button" mat-button (click)="onCancel()">
    <mat-icon>clear</mat-icon>
  </button>
</div>
<app-view-story [isInstigatedViaViewingStory]="true"></app-view-story>
